import type { SVGProps } from "react";
export interface GarlicIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GarlicIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GarlicIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 14c0-2.442 1.25-4.216 2.83-5.796l1.212-1.199c.412-.408.825-.82 1.212-1.223.383-.397.723-.767.992-1.09.281-.336.438-.567.503-.695l.085-.19c.171-.44.166-.87.166-1.807a1.125 1.125 0 0 1 2.25 0c0 .813.041 1.674-.312 2.602l-.177.4c-.185.372-.482.767-.788 1.133-.318.38-.698.793-1.097 1.207-.79.821-1.728 1.727-2.455 2.454-1.42 1.42-2.171 2.647-2.171 4.204 0 2.1 2.259 4.706 6.444 4.866l.41.009.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006-.485-.01C4.52 20.918.875 17.713.875 14m20 0c0-1.557-.751-2.785-2.17-4.204-.727-.727-1.664-1.633-2.455-2.454-.4-.414-.78-.826-1.099-1.207a8 8 0 0 1-.63-.85l-.158-.282c-.541-1.083-.487-2.074-.487-3.003a1.125 1.125 0 0 1 2.25 0c0 1.07-.008 1.48.25 1.997l.066.115a6 6 0 0 0 .436.58c.27.323.61.693.992 1.09.774.804 1.653 1.649 2.426 2.422l.576.603c1.297 1.432 2.253 3.056 2.253 5.193 0 3.832-3.883 7.125-9.104 7.125a1.126 1.126 0 0 1 0-2.25c4.447 0 6.853-2.707 6.854-4.875"
      />
      <path
        fill={color}
        d="M10.875 22v-.487a5 5 0 0 1-.458-.113l-.48.724a1.125 1.125 0 0 1-1.873-1.248l.416-.626a5.5 5.5 0 0 1-1.216-1.902c-.66-1.69-.647-3.668-.367-5.069.42-2.104 1.218-3.959 1.86-5.505C9.431 6.15 9.875 4.982 9.875 4V2A1.12 1.12 0 0 1 12 1.496 1.12 1.12 0 0 1 14.125 2v2c0 .982.443 2.15 1.117 3.774.642 1.546 1.44 3.401 1.86 5.505.28 1.4.294 3.38-.367 5.069a5.5 5.5 0 0 1-1.217 1.902l.417.626a1.125 1.125 0 0 1-1.803 1.34l-.069-.092-.482-.724q-.222.067-.457.113V22a1.125 1.125 0 0 1-2.25 0ZM12 5.204c-.22 1.146-.7 2.315-1.164 3.432-.578 1.392-1.188 2.825-1.58 4.4l-.153.683c-.22 1.1-.207 2.621.258 3.807.226.579.54 1.031.94 1.338q.075.056.158.108.086.039.166.091l.026.019c.346.177.783.292 1.35.292.564 0 1-.116 1.347-.292a1 1 0 0 1 .199-.113q.08-.05.152-.105c.4-.307.715-.76.94-1.338.465-1.186.479-2.707.259-3.807-.37-1.848-1.073-3.493-1.733-5.083C12.7 7.52 12.22 6.351 12 5.205Z"
      />
    </svg>
  );
}
